import React, { Fragment } from 'react';

import {
  StyledLabelP,
  StyledFullButton,
  ButtonContainerStyled,
} from 'helpers/StyledLoginComponentsHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';

export default ({ changeVerificationMethod, details }) => {
  return (
    <Fragment>
      <StyledLabelP>{getTranslatedString('login.havingTrouble')}</StyledLabelP>
      <ButtonContainerStyled>
        <StyledFullButton
          name="submit"
          inputProps={{ 'aria-label': 'Send code via SMS' }}
          data-testid="login-button"
          id={'login-button'}
          primary={true}
          onClick={() => changeVerificationMethod('mobile')}
          accentColor={AccentColor()}
          disabled={!details.isButtonEnabled}
          labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
        >
          Send code via SMS
        </StyledFullButton>

        <StyledFullButton
          name="submit"
          inputProps={{ 'aria-label': 'Send via Email' }}
          data-testid="login-button"
          id={'login-button'}
          primary={true}
          onClick={() => changeVerificationMethod('email')}
          accentColor={AccentColor()}
          disabled={!details.isButtonEnabled}
          labelStyle={{ textTransform: 'capitalize', fontSize: '18px' }}
        >
          Send via Email
        </StyledFullButton>
      </ButtonContainerStyled>
    </Fragment>
  );
};
